(() => {
  if (window.olaCartStateSync) return;
  window.olaCartStateSync = true;
  const script = document.currentScript;
  const cartUrl = script.dataset.cartUrl || '/cart';
  const moneyFormat = script.dataset.moneyFormat;
  const originalFetch = window.fetch;
  const waiting = [], queued = new WeakSet(), allowed = new WeakSet();
  const accessoryFeedback = new Map();
  let pendingCartNavigation = null, navigationTimer, addFailed = false;
  let active = 0, revision = 0, timer, reading = false, dirty = false, running = null;
  const cartRequest = value => {
    try {
      const url = new URL(typeof value === 'string' || value instanceof URL ? value : value.url, location.href);
      return url.origin === location.origin && /\/cart(?:\/(add|change|update|clear))?(?:\.js)?\/?$/.test(url.pathname);
    } catch { return false; }
  };
  const mutation = value => {
    try { return /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(new URL(typeof value === 'string' || value instanceof URL ? value : value.url, location.href).pathname); }
    catch { return false; }
  };
  function schedule() { clearTimeout(timer); timer = setTimeout(settle, 120); }
  function start(writes) { active += 1; revision += 1; dirty = dirty || writes; clearTimeout(timer); }
  function finish() { active = Math.max(0, active - 1); if (dirty || running || waiting.length) schedule(); }
  function selection(form) {
    return ['id', 'quantity', 'selling_plan'].map(name => [...form.querySelectorAll(`[name="${name}"]`)].map(el => el.value).join('|')).join(';');
  }
  function mainState(task) {
    const button = task.mainButton;
    if (!button) return null;
    const section = task.form.closest('[id^="shopify-section-"]');
    const source = section?.querySelector('script[data-section-type="static-product"][data-section-data]');
    try {
      const data = JSON.parse(source?.textContent || '{}');
      const id = task.form.querySelector('[name="id"]')?.value;
      const variant = data.product?.variants.find(item => String(item.id) === String(id));
      if (variant && data.context) return { disabled: !variant.available, text: variant.available ? data.context.product_available : data.context.product_unavailable };
    } catch { }
    return { disabled: button.classList.contains('disabled') || task.buttonState.disabled, text: task.nativeText || task.buttonState.text };
  }
  function restoreMain(task) {
    if (!task.mainButton) return;
    task.buttonObserver?.disconnect(); task.buttonObserver = null;
    const state = mainState(task), button = task.mainButton;
    (button.querySelector('[data-product-atc-text]') || button).textContent = state.text;
    button.disabled = state.disabled;
    button.classList.toggle('disabled', state.disabled);
    button.classList.remove('processing');
    button.removeAttribute('data-ola-cart-phase');
    if (task.buttonState.busy === null) button.removeAttribute('aria-busy');
    else button.setAttribute('aria-busy', task.buttonState.busy);
  }
  function clearAccessoryFeedback(form) {
    const task = accessoryFeedback.get(form);
    if (task) { restoreMain(task); accessoryFeedback.delete(form); }
  }
  function showAccessoryFeedback() {
    document.querySelectorAll('[data-product-atc]').forEach(button => {
      const form = button.closest('form');
      if (!form || queued.has(form) || accessoryFeedback.has(form)) return;
      const task = { form, mainButton: button, buttonState: { disabled: button.disabled, busy: button.getAttribute('aria-busy'), text: (button.querySelector('[data-product-atc-text]') || button).textContent.trim() } };
      accessoryFeedback.set(form, task);
      mainPhase(task, 'accessories');
    });
  }
  function navigationStatus(text) {
    let status = document.querySelector('[data-ola-navigation-status]');
    if (!status) { status = document.createElement('p'); status.dataset.olaNavigationStatus = ''; status.setAttribute('role', 'status'); status.tabIndex = -1; (document.querySelector('ola-product-addons') || document.body).append(status); }
    status.textContent = text;
    return status;
  }
  function finishFeedback() {
    if (running || waiting.length || active || reading || dirty) return;
    [...accessoryFeedback.keys()].forEach(clearAccessoryFeedback);
    if (pendingCartNavigation) {
      const destination = pendingCartNavigation;
      pendingCartNavigation = null; clearTimeout(navigationTimer);
      if (addFailed || [...document.querySelectorAll('ola-product-addons .oa-status')].some(el => el.textContent.trim())) navigationStatus('An item could not be confirmed. Select View cart again to check your cart.');
      else location.assign(destination);
    }
  }
  function mainPhase(task, phase) {
    if (!task.mainButton) return;
    task.phase = phase;
    const button = task.mainButton;
    const label = phase === 'adding' ? script.dataset.addingCart : phase === 'accessories' ? script.dataset.addingAccessories : script.dataset.updatingCart;
    const apply = () => {
      const text = button.querySelector('[data-product-atc-text]') || button;
      if (text.textContent.trim() !== label) text.textContent = label;
      if (!button.disabled) button.disabled = true;
      if (button.getAttribute('aria-busy') !== 'true') button.setAttribute('aria-busy', 'true');
      button.setAttribute('data-ola-cart-phase', phase);
    };
    task.buttonObserver?.disconnect();
    apply();
    task.buttonObserver = new MutationObserver(() => {
      const text = (button.querySelector('[data-product-atc-text]') || button).textContent.trim();
      if (text !== label && ![script.dataset.addingCart, script.dataset.addingAccessories, script.dataset.updatingCart].includes(text)) task.nativeText = text;
      apply();
    });
    task.buttonObserver.observe(button, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, characterData: true, subtree: true });
  }
  function unlock(task) {
    clearTimeout(task.timeout);
    task.controls.forEach(([el, disabled]) => { el.disabled = disabled; });
    if (task.card) {
      if (task.pending === undefined) delete task.card.dataset.pending;
      else task.card.dataset.pending = task.pending;
    }
    queued.delete(task.form);
    restoreMain(task);
  }
  function message(task, text) {
    const widget = task.form.closest('ola-product-addons');
    let status = widget?.querySelector('.oa-status') || task.form.querySelector('[data-ola-cart-status]');
    if (!status) { status = document.createElement('p'); status.dataset.olaCartStatus = ''; status.setAttribute('role', 'status'); task.form.append(status); }
    status.textContent = text;
  }
  function cancelWaiting(text) {
    waiting.splice(0).forEach(task => { unlock(task); message(task, text); });
  }
  function complete() {
    if (running) { clearTimeout(running.timeout); (running.group || [running]).forEach(task => { queued.delete(task.form); restoreMain(task); }); running = null; }
    drain();
    finishFeedback();
  }
  function drain() {
    if (running || active || reading) return;
    if (!waiting.length) { finishFeedback(); return; }
    const task = waiting.shift();
    unlock(task);
    if (!task.form.isConnected || selection(task.form) !== task.selection) {
      addFailed = true;
      if (task.form.isConnected) message(task, script.dataset.selectionChanged);
      drain(); return;
    }
    running = task; queued.add(task.form);
    const widget = task.card?.closest('ola-product-addons');
    if (task.addonIntent === 'add' && widget?.olaDraftBatchVersion === 'v16-1' && typeof widget.addBatch === 'function') {
      task.group = [task];
      while (waiting.length) {
        const next = waiting[0];
        if (next.addonIntent !== 'add' || next.card?.closest('ola-product-addons') !== widget || !next.form.isConnected || selection(next.form) !== next.selection) break;
        waiting.shift(); unlock(next); queued.add(next.form); task.group.push(next);
      }
    }
    task.timeout = setTimeout(() => {
      if (running !== task) return;
      message(task, script.dataset.cartTimeout);
      cancelWaiting(script.dataset.cartTimeout);
      (task.group || [task]).forEach(member => { queued.delete(member.form); restoreMain(member); }); running = null;
      addFailed = true;
      [...accessoryFeedback.keys()].forEach(clearAccessoryFeedback);
    }, 30000);
    allowed.add(task.form);
    try {
      if (task.group) {
        task.batchPending = true;
        Promise.resolve(widget.addBatch(task.group.map(member => member.card))).then(result => { if (!result?.ok) addFailed = true; }, () => { addFailed = true; message(task, script.dataset.cartTimeout); }).finally(() => { task.batchPending = false; schedule(); });
      }
      else if (task.submitter?.isConnected && !task.submitter.disabled) task.form.requestSubmit(task.submitter);
      else task.form.requestSubmit();
      if (running === task) mainPhase(task, 'adding');
    } catch { message(task, script.dataset.cartTimeout); complete(); }
    finally { allowed.delete(task.form); }
    schedule();
  }
  async function settle() {
    if (active || reading) return;
    if (running?.batchPending) { schedule(); return; }
    if (running && waiting.length && running.card?.dataset.pending !== 'true') {
      complete();
      if (!running) schedule();
      return;
    }
    if (!dirty) {
      if (running?.card?.dataset.pending === 'true') { schedule(); return; }
      complete(); return;
    }
    reading = true;
    const current = revision;
    try {
      const response = await originalFetch.call(window, `${cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (current !== revision || active) { schedule(); return; }
      if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || !Number.isInteger(cart.total_price)) return;
      dirty = false;
      document.querySelectorAll('[data-header-cart-count]').forEach(el => {
        el.setAttribute('data-header-cart-count', String(cart.item_count));
        el.classList.toggle('visible', cart.item_count > 0);
        el.closest('.site-header-cart-button')?.classList.toggle('count-hidden', cart.item_count === 0);
      });
      document.querySelectorAll('[data-atc-banner-cart-button] span').forEach(el => { el.textContent = String(cart.item_count); });
      if (window.Shopify?.formatMoney) document.querySelectorAll('[data-atc-banner-cart-subtotal]').forEach(el => { el.innerHTML = window.Shopify.formatMoney(cart.total_price, moneyFormat); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'ola-theme-sync' } }));
      schedule();
    } catch { }
    finally { reading = false; }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !mutation(form.action) || !/\/cart\/add(?:\.js)?\/?$/.test(new URL(form.action, location.href).pathname)) return;
    if (allowed.has(form)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (queued.has(form)) return;
    if (!running && !waiting.length && !active) addFailed = false;
    clearAccessoryFeedback(form);
    const card = form.closest('.oa-card');
    const scope = card || form;
    const task = { form, submitter: event.submitter, selection: selection(form), card, pending: card?.dataset.pending, controls: [...scope.querySelectorAll('button,input,select,textarea')].map(el => [el, el.disabled]) };
    task.mainButton = card ? null : form.querySelector('[data-product-atc]');
    if (task.mainButton) {
      const button = task.mainButton;
      task.buttonState = { disabled: button.disabled, busy: button.getAttribute('aria-busy'), text: (button.querySelector('[data-product-atc-text]') || button).textContent.trim() };
    }
    task.addonIntent = card ? (event.submitter?.dataset.action || 'add') : null;
    const behindAccessories = Boolean((running?.card && running.addonIntent === 'add') || waiting.some(item => item.card && item.addonIntent === 'add'));
    queued.add(form);
    task.controls.forEach(([el]) => { el.disabled = true; });
    if (card) card.dataset.pending = 'true';
    mainPhase(task, behindAccessories ? 'accessories' : 'updating');
    task.timeout = setTimeout(() => {
      const index = waiting.indexOf(task);
      if (index !== -1) { waiting.splice(index, 1); unlock(task); message(task, script.dataset.cartTimeout); addFailed = true; finishFeedback(); }
    }, 30000);
    waiting.push(task);
    if (card && task.addonIntent === 'add') showAccessoryFeedback();
    setTimeout(drain, 0);
  }, true);
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, location.href), cartPath = new URL(cartUrl, location.href).pathname.replace(/\/$/, '');
    if (destination.origin !== location.origin || destination.pathname.replace(/\/$/, '') !== cartPath || !(running || waiting.length || accessoryFeedback.size)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    pendingCartNavigation = destination.href;
    navigationStatus('Finishing your requested items before opening the cart…').focus();
    clearTimeout(navigationTimer);
    navigationTimer = setTimeout(() => {
      pendingCartNavigation = null;
      navigationStatus('Items are taking longer than expected. Check the add-on messages, then select View cart again.');
    }, 30000);
  }, true);
  window.fetch = function (...args) {
    if (!cartRequest(args[0])) return originalFetch.apply(this, args);
    start(mutation(args[0]));
    try { return originalFetch.apply(this, args).then(response => { if (!response.ok && (running || waiting.length)) addFailed = true; finish(); return response; }, error => { if (running || waiting.length) addFailed = true; finish(); throw error; }); }
    catch (error) { finish(); throw error; }
  };
  const originalOpen = XMLHttpRequest.prototype.open, originalSend = XMLHttpRequest.prototype.send;
  const requests = new WeakMap();
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    requests.delete(this);
    if (cartRequest(url)) requests.set(this, mutation(url) && String(method).toUpperCase() !== 'GET');
    return originalOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (!requests.has(this)) return originalSend.apply(this, args);
    start(requests.get(this));
    let completed = false;
    const end = () => { if (!completed) { completed = true; if ((running || waiting.length) && (this.status === 0 || this.status >= 400)) addFailed = true; finish(); } };
    this.addEventListener('loadend', end, { once: true });
    try { return originalSend.apply(this, args); }
    catch (error) { this.removeEventListener('loadend', end); end(); throw error; }
  };
  new MutationObserver(records => {
    const confirmedBanner = records.some(record => [...record.addedNodes].some(node => {
      if (node.nodeType !== 1) return false;
      const banner = node.matches('[data-atc-banner]') ? node : node.querySelector('[data-atc-banner]');
      return banner && !banner.closest('[data-templates]');
    }));
    if (confirmedBanner) {
      // Superstore appends this banner only after add success and its cart read.
      // Confirmation changes the label, not the mutation/nav settlement barrier.
      if (running?.mainButton && running.phase === 'adding') mainPhase(running, 'updating');
      dirty = true; schedule();
    }
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', event => { if (event.persisted) { dirty = true; schedule(); } });
})();
